// Column-name → unit URI heuristic. Mirror of `unit_catalog/data/heuristic-aliases.json`.
// Kept in sync manually (16 entries, low churn). If you change this list,
// update the canonical JSON in unit_catalog too — the picker reads this
// copy because client_core / wasm_client cannot depend on unit_catalog (the
// boundary rule in unit_catalog/README.md).

interface AliasEntry {
  suffix: string;
  uri: string;
}

const ALIASES: AliasEntry[] = [
  { suffix: "_kg", uri: "unit:KiloGM" },
  { suffix: "_g", uri: "unit:GM" },
  { suffix: "_lb", uri: "unit:LB" },
  { suffix: "_oz", uri: "unit:OZ" },
  { suffix: "_usd", uri: "unit:CCY_USD" },
  { suffix: "_eur", uri: "unit:CCY_EUR" },
  { suffix: "_gbp", uri: "unit:CCY_GBP" },
  { suffix: "_jpy", uri: "unit:CCY_JPY" },
  { suffix: "_pct", uri: "unit:PERCENT" },
  { suffix: "_percent", uri: "unit:PERCENT" },
  { suffix: "_sec", uri: "unit:SEC" },
  { suffix: "_seconds", uri: "unit:SEC" },
  { suffix: "_ms", uri: "unit:MilliSEC" },
  { suffix: "_min", uri: "unit:MIN" },
  { suffix: "_hr", uri: "unit:HR" },
  { suffix: "_hours", uri: "unit:HR" },
];

// _m (meter vs minute) and _d (day vs density) are intentionally absent —
// column-name shape cannot disambiguate without extra context.

function stripTrailingDigits(s: string): string {
  return s.replace(/\d+$/, "").replace(/_$/, "").replace(/\d+$/, "");
}

export function matchColumnNameToUnit(columnName: string): string | null {
  if (!columnName) return null;
  const lower = columnName.toLowerCase();
  const trimmed = stripTrailingDigits(lower);
  for (const entry of ALIASES) {
    if (lower.endsWith(entry.suffix) || trimmed.endsWith(entry.suffix)) {
      return entry.uri;
    }
  }
  return null;
}

// Hook is a thin pure-function call; kept as a hook for symmetry with
// useUnitSearch and to allow future evolution (e.g. memoization, async match).
export function useHeuristicMatch(
  columnName: string | undefined,
): string | null {
  if (!columnName) return null;
  return matchColumnNameToUnit(columnName);
}
